import script from "./FormularioDatosFiscales.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioDatosFiscales.vue?vue&type=script&setup=true&lang=js"

import "./FormularioDatosFiscales.vue?vue&type=style&index=0&id=c46e3480&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46e3480"]])

export default __exports__